define("powergen/routes/admin",
  [],
  function() {
    "use strict";
    var AdminRoute;

    AdminRoute = Ember.Route.extend({
      model: function() {
        var _this = this;
        return Ember.RSVP.Promise(function(resolveModel, rejectModel) {
          var promises;
          promises = {
            scores: Ember.RSVP.Promise(function(resolve, reject) {
              return _this.get('store').findAll('score').then(function(scores) {
                return resolve(scores);
              });
            })
          };
          return Ember.RSVP.hash(promises).then(function(promises) {
            var model;
            model = Ember.Object.create({
              scores: promises.scores
            });
            return resolveModel(model);
          });
        });
      }
    });


    return AdminRoute;
  });